export default "__VITE_ASSET__fe7c2892__"